
<ng-container *ngIf="!assetTypeClassificationForm">
    <acabim-loading-view></acabim-loading-view>
</ng-container>

<ng-container *ngIf="assetTypeClassificationForm">
    <form [formGroup]="assetTypeClassificationForm">
        <ng-container *ngIf="!loading">
            <acabim-form-card-section>
                <p-toast key="contactTypeNameMissing" position="top-left"></p-toast>
                <div class="cas-form-text-input">
                    <h6>Name</h6>
                    <div class="p-inputgroup p-float-label">
                        <input type="text" formControlName="name" id="contact-type-name" placeholder="Enter a contact type name">
                    </div>
                </div>
                <div class="cas-form-text-input">
                    <h6>Description</h6>
                    <div class="p-inputgroup p-float-label">
                        <input type="text" formControlName="description" id="contact-type-description" placeholder="Enter a contact type description">
                    </div>
                </div>
                <div class="cas-action-buttons">
                    <button (click)="onCancel()">Cancel</button>
                    <button class="cas-button-action" (click)="onGo(2)">Next</button>
                </div>
            </acabim-form-card-section>
        </ng-container>

    </form>
</ng-container>
